import PrismicLink from '@components/PrismicLink';

const CustomPrismicLink = (type, element, content, children, index) => {
  return (
    <PrismicLink key={index} link={element.data}>
      {content}
    </PrismicLink>
  );
};

export default CustomPrismicLink;
